<script setup lang="ts">
import { OverlayBadge } from '@dashhudson/dashing-ui/badge';
import { Button } from '@dashhudson/dashing-ui/button';
import { useDrawer } from '@dashhudson/dashing-ui/drawer';

import { useReleasePanelNotification } from '@/composables/useReleasePanelNotification';

const { launchDrawer } = useDrawer();
const { hasNewReleaseNotes, markAsSeen } = useReleasePanelNotification();

function openReleasePanel() {
  markAsSeen();
  launchDrawer({ name: 'releaseHub' });
}
</script>

<template>
  <OverlayBadge
    :show="hasNewReleaseNotes"
    size="xs"
    badge-class="-translate-x-[12px] translate-y-[9px]"
  >
    <Button severity="utility" icon="gift" size="lg" @click="openReleasePanel" />
  </OverlayBadge>
</template>
